import React from 'react';
import './DrinkResponsibly.css';
import './FoodSupport.css';

function FoodSupport() {
  return (
    <div className="drink-responsibly food-support-page">
      <section className="dr-header">
        <h1>Food Support &amp; Allergy Safety</h1>
        <p>Meal planning should support—not judge—your family’s needs.</p>
      </section>

      <section className="dr-content">
        <div className="content-wrapper">
          <div className="emergency-section">
            <h2>Urgent Help</h2>
            <div className="emergency-cards">
              <div className="emergency-card">
                <h3>Possible Anaphylaxis</h3>
                <p className="phone-number">
                  <a href="tel:911">Call 911</a>
                </p>
                <p>
                  Follow the person’s emergency plan. For severe symptoms, Food Allergy Research &amp;
                  Education advises giving prescribed epinephrine promptly and calling 911.
                </p>
                <p>
                  <a href="https://www.foodallergy.org/resources/recognizing-and-responding-reaction" target="_blank" rel="noopener noreferrer">
                    Recognize and respond to a reaction
                  </a>
                </p>
              </div>

              <div className="emergency-card">
                <h3>Mental Health Crisis</h3>
                <p className="phone-number">
                  Call or text <a href="tel:988">988</a>
                </p>
                <p>Free, confidential crisis support is available in the United States 24/7.</p>
                <p>
                  <a href="https://988lifeline.org/get-help/what-to-expect/" target="_blank" rel="noopener noreferrer">
                    What to expect from the 988 Lifeline
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="resources-grid">
            <div className="resource-section">
              <h2>Eating Patterns &amp; Overeating</h2>

              <div className="resource-item">
                <h3>National Eating Disorders Association</h3>
                <p>
                  Find a confidential screening, treatment information, and support for concerns such as
                  binge eating, loss of control around food, or distress about eating.
                </p>
                <p><strong>Get help:</strong> <a href="https://www.nationaleatingdisorders.org/get-help/" target="_blank" rel="noopener noreferrer">nationaleatingdisorders.org/get-help</a></p>
                <p><strong>Find treatment:</strong> <a href="https://map.nationaleatingdisorders.org/" target="_blank" rel="noopener noreferrer">NEDA Treatment Map</a></p>
              </div>

              <div className="resource-item">
                <h3>Overeaters Anonymous</h3>
                <p>
                  A peer-support fellowship for people who want help with compulsive eating and related
                  food behaviors. It is not a substitute for medical or mental-health care.
                </p>
                <p><strong>Find a meeting:</strong> <a href="https://oa.org/find-a-meeting/" target="_blank" rel="noopener noreferrer">oa.org/find-a-meeting</a></p>
              </div>
            </div>

            <div className="resource-section">
              <h2>Food-Allergy Preparedness</h2>

              <div className="resource-item">
                <h3>Emergency Care Plan</h3>
                <p>
                  Work with a qualified clinician to create an allergy and anaphylaxis plan, then keep it
                  available to everyone who prepares or serves food.
                </p>
                <p><strong>Template:</strong> <a href="https://www.foodallergy.org/sites/default/files/2025-08/ECP-FAAP_Plan_English_8_13_25.pdf" target="_blank" rel="noopener noreferrer">FARE emergency care plan (PDF)</a></p>
              </div>

              <div className="resource-item">
                <h3>Labels &amp; Major Allergens</h3>
                <p>
                  The FDA explains U.S. allergen-labeling requirements and the nine major food allergens.
                  Check the package every time; ingredients and manufacturing can change.
                </p>
                <p><strong>Guide:</strong> <a href="https://www.fda.gov/food/nutrition-food-labeling-and-critical-foods/food-allergies" target="_blank" rel="noopener noreferrer">FDA food-allergy information</a></p>
              </div>
            </div>

            <div className="resource-section">
              <h2>Safer Everyday Meals</h2>

              <div className="resource-item">
                <h3>Avoiding Cross-Contact</h3>
                <p>
                  Learn how allergen proteins can transfer between foods, utensils, surfaces, and cooking
                  equipment—and how cleaning differs from simply cooking the food.
                </p>
                <p><strong>Guide:</strong> <a href="https://www.foodallergy.org/resources/avoiding-cross-contact" target="_blank" rel="noopener noreferrer">FARE cross-contact guidance</a></p>
              </div>

              <div className="resource-item">
                <h3>Dining Out</h3>
                <p>
                  Call ahead, explain the allergy to a manager or chef, ask about preparation, and carry
                  prescribed medication according to the person’s care plan.
                </p>
                <p><strong>Guide:</strong> <a href="https://www.foodallergy.org/resources/dining-out" target="_blank" rel="noopener noreferrer">FARE dining-out guidance</a></p>
              </div>

              <div className="resource-item">
                <h3>Using DishList</h3>
                <p>
                  DishList’s allergy and attendance information can help a family plan, but it is not a
                  medical record and cannot verify ingredients, preparation, or cross-contact.
                </p>
              </div>
            </div>
          </div>

          <div className="info-section">
            <h2>Support Without Shame</h2>
            <div className="info-content">
              <ul>
                <li><strong>Food is not a moral test.</strong> People deserve support regardless of what or how much they eat.</li>
                <li><strong>Listen to the person affected.</strong> Avoid teasing, blame, pressure, or commenting on bodies.</li>
                <li><strong>Ask a professional.</strong> A doctor, registered dietitian, allergist, or therapist can help build an individualized plan.</li>
                <li><strong>Verify every meal.</strong> App preferences are planning aids, not allergy-safety guarantees.</li>
              </ul>
            </div>
          </div>

          <div className="disclaimer-section">
            <h2>Disclaimer</h2>
            <p>
              This page provides general educational resources and is not medical advice, diagnosis, or
              treatment. Consult qualified health professionals for individual guidance. In an emergency,
              call 911 or your local emergency number.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FoodSupport;
